import React from "react";
import theme from "app/Theme/Theme";
import { StyleSheet, Text, TouchableOpacity } from "react-native";
import { MainText } from "app/components/common";

const styles = StyleSheet.create({
  main: {
    height: 28,
    width: 40,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "column",
    borderWidth: 2,
    borderRadius: 8,
    borderColor: theme.colors["neutral.100"],
    backgroundColor: theme.colors["neutral.100"],
  },
  circleSelected: {
    borderColor: theme.colors["brand.500"],
    backgroundColor: theme.colors["brand.100"],
  },
  text: {
    color: theme.colors["neutral.600"],
    fontWeight: "500",
    fontSize: 14,
  },
  textSelected: {
    color: theme.colors["brand.500"],
  },
});

const DayCircle = ({ text, isSelected = false, onPress }) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      style={[styles.main, isSelected && styles.circleSelected]}
    >
      <MainText
        variant="l3-medium"
        color={isSelected ? "brand.500" : "neutral.600"}
      >
        {text}
      </MainText>
    </TouchableOpacity>
  );
};

export default DayCircle;
